import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import { clock, HOUR_MS } from "clock";
var OtEventList = /** @class */ (function (_super) {
    tslib_1.__extends(OtEventList, _super);
    function OtEventList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clock = clock;
        return _this;
    }
    OtEventList.prototype.mounted = function () {
        var _this = this;
        this.$watch("todayEvents", function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Terrible hack to force currentTimeStyle to recalculate
                    return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        // Terrible hack to force currentTimeStyle to recalculate
                        _a.sent();
                        //setTimeout(() => {
                        this.$forceUpdate();
                        return [2 /*return*/];
                }
            });
        }); }, { immediate: true });
    };
    OtEventList.prototype.currentTimeStyle = function () {
        // Calculating pixels in code is terrible but probably the only way to get things to line up in this case
        var table = this.$refs.eventTable;
        if (!table)
            return null;
        var timeOfDay = clock.nowMinute.getTime() - clock.today.getTime(), hourOffset = Math.min(Math.max(0, (timeOfDay / HOUR_MS) - this.hours[0]), this.hours.length), hourIndex = Math.floor(hourOffset), hourFraction = (hourOffset - hourIndex);
        var tableBounds = table.getBoundingClientRect(), cellBounds = table.rows[0].cells[hourIndex + 1].getBoundingClientRect();
        return {
            left: ((cellBounds.left - tableBounds.left) + (hourFraction * cellBounds.width)) + "px",
            height: (tableBounds.height - cellBounds.height) + "px",
        };
    };
    Object.defineProperty(OtEventList.prototype, "hours", {
        get: function () {
            var hours = [];
            for (var i = 8; i <= 23; i++)
                hours.push(i);
            return hours;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OtEventList.prototype, "organizers", {
        get: function () {
            var e_1, _a;
            var organizers = [];
            try {
                for (var _b = tslib_1.__values(this.todayEvents), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var ev = _c.value;
                    if (organizers.indexOf(ev.organizer) == -1)
                        organizers.push(ev.organizer);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return organizers;
        },
        enumerable: true,
        configurable: true
    });
    OtEventList.prototype.getFirstName = function (fullName) {
        return fullName.split(" ")[0] || "";
    };
    OtEventList.prototype.getOrganizerReservations = function (organizer, hour) {
        var e_2, _a;
        var hourStart = new Date(clock.today).setHours(hour);
        var hourEnd = new Date(clock.today).setHours(hour + 1);
        var reservations = [];
        try {
            for (var _b = tslib_1.__values(this.todayEvents), _c = _b.next(); !_c.done; _c = _b.next()) {
                var ev = _c.value;
                if (ev.organizer === organizer && ev.start.getTime() < hourEnd && ev.end.getTime() > hourStart) {
                    var start = Math.max(hourStart, ev.start.getTime());
                    var end = Math.min(hourEnd, ev.end.getTime());
                    reservations.push({
                        startPercent: ((start - hourStart) / HOUR_MS) * 100,
                        lengthPercent: ((end - start) / HOUR_MS) * 100,
                    });
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return reservations;
    };
    tslib_1.__decorate([
        Prop(),
        tslib_1.__metadata("design:type", Object)
    ], OtEventList.prototype, "calendar", void 0);
    tslib_1.__decorate([
        Prop(),
        tslib_1.__metadata("design:type", Array)
    ], OtEventList.prototype, "todayEvents", void 0);
    OtEventList = tslib_1.__decorate([
        Component
    ], OtEventList);
    return OtEventList;
}(Vue));
export default OtEventList;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/components/OtEventList.vue
// module id = 222
// module chunks = 0